import {
  FETCH_DEVICES_SUCCESS,
  FETCH_DEVICE_SUCCESS,
} from "../../constants/ActionTypes";

const initialSettings = {};

export default (state = initialSettings, action) => {
  switch (action.type) {
    case FETCH_DEVICES_SUCCESS: {
      return { ...state, index: action.payload };
    }
    case FETCH_DEVICE_SUCCESS: {
      return { ...state, show: action.payload };
    }
    default:
      return state;
  }
};
